module.exports = __webpack_public_path__ + "img/audio_gif.6098162a.gif";